import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fsm',
  templateUrl: './fsm.component.html',
  styleUrls: ['./fsm.component.css']
})
export class FsmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
